// extracted by mini-css-extract-plugin
module.exports = {"nav":"QalbN","item":"_9WYkq","link":"_1jly0"};